import { render, staticRenderFns } from "./TilesTable.vue?vue&type=template&id=21ee1c28&scoped=true"
import script from "./TilesTable.vue?vue&type=script&lang=js"
export * from "./TilesTable.vue?vue&type=script&lang=js"
import style0 from "./TilesTable.vue?vue&type=style&index=0&id=21ee1c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee1c28",
  null
  
)

export default component.exports